import {Variants, motion} from 'framer-motion';
import styled from 'styled-components';

import {ReactNode} from 'react';

interface CollapseProps {
  isOpen: boolean;
  children: ReactNode;
}

const VARIANT_KEY = {
  EXIT: 'exit',
  ENTER: 'enter',
};

const ease = [0.25, 0.1, 0.25, 1] as const;

const defaultTransitions = {
  [VARIANT_KEY.EXIT]: {
    height: {duration: 0.2, ease},
    opacity: {duration: 0.3, ease},
  },
  [VARIANT_KEY.ENTER]: {
    height: {duration: 0.2, ease},
    opacity: {duration: 0.4, ease},
  },
};

const variants: Variants = {
  exit: {
    height: 0,
    opacity: 0,
    overflow: 'hidden',
    transition: defaultTransitions.exit,
  },
  enter: {
    height: 'auto',
    opacity: 1,
    transition: defaultTransitions.enter,
  },
};

export function Collapse(props: CollapseProps) {
  return (
    <StyledMotionContent
      variants={variants}
      animate={props.isOpen ? 'enter' : 'exit'}
      aria-hidden={!props.isOpen}
      initial={false}
    >
      {props.children}
    </StyledMotionContent>
  );
}

const StyledMotionContent = styled(motion.div)`
  overflow: hidden;
  display: block;
`;
